$(function(){
  $(" form .referrer").val(location.href)
})


function back(id) {
  var timer = null 
  if(document.body.clientWidth > 1001) {

    $("#"+id).siblings().fadeOut(700,function(){
      $("#"+id).fadeIn('fast') 
    })

  } else {
    $("#"+id).siblings().fadeOut(700,function(){
      $("#"+id).fadeIn('fast')   
    })
  }

  
  $(".Form__Alert").css("visibility",'hidden')
  $("input").removeClass("is-error")
  $(".Alert--error").html("").css("visibility","hidden")
  gtag('event', 'click', {
    'event_category': event_category,
    'event_action': 'click',
    'event_label': `${activityName}::${ id == 'login' ? 'SIGN IN':'SIGN UP'}`
  });
}
function forGetPassword() {
  location.href='/account/login#recover'
}
function validInput(event,pageType,selector) {
  var formId = null
  var field='',inputValue=''
  if(event) {
    formId = $(event.currentTarget).parent().parent().attr("id")
    field = event.target.name
    inputValue = event.currentTarget.value
  } else {
    field = selector.name
    inputValue = selector.value
  }
  var errorMsg = ''
  var rules = {
    'customer[email]': [
      {
        required: true,
        error: 'Please enter Email.'
      }, {
        regex: '^[A-Za-z0-9]+([_\.][A-Za-z0-9]+)*@([A-Za-z0-9\-]+\.)+[A-Za-z]+$',
        error: 'The email you entered is invalid.'
      }
    ],
    'email': [
      {
        required: true,
        error: 'Please enter Email'
      }, {
        regex: '^[A-Za-z0-9]+([_\.][A-Za-z0-9]+)*@([A-Za-z0-9\-]+\.)+[A-Za-z]+$',
        error: 'The email you entered is invalid.'
      }
    ],
    'customer[password]': [{
      required: true,
      error: 'Please enter your password.'
    }],
    'confirmPwd': [{
      required: true,
      error: 'Please enter your password.'
    }]
  }
  var fieldRule = rules[field]
  try {
    fieldRule.forEach(function (item) {
      if (item.required && !inputValue) {
        errorMsg = item.error
        throw Error();
      } else if (item.min || item.max) {
        if (inputValue.length < item.min || item.max < inputValue.length) {
          errorMsg = item.error
          throw Error();
        }
      } else if (item.regex) {
        var reg = new RegExp(item.regex)
        if (!reg.test(inputValue)) {
          errorMsg = item.error
          throw Error();
        }
      }
    })
  } catch (error) {

  }
  // 如果是注册页，则校验两次密码是否一致
  if(pageType == 'register' && !errorMsg && field == 'confirmPwd') {
    if($("#pwd1").val() && $("#pwd2").val() && $("#pwd2").val() != $("#pwd1").val()) {
      errorMsg = 'You two entered passwords do not match.'
    }
  }
  if (errorMsg) {
    var ele = formId ? '#'+formId : '#'+pageType
    $( ele + ' input[name="' + field + '"]').addClass("is-error").siblings(".error-msg").text(errorMsg)
    return false
  }
  return true
}
function clearValid(event) {
  var field = event.target.name
  $('input[name="' + field + '"]').removeClass("is-error").next().text('')
  $(".Form__Alert").remove()
}
function accountLoginGaView() {
  var category = isPopup ? 'LoginRegisterPopup': 'account page'
  gtag('event', 'view', {
    'event_category': category,
    'event_action': 'signInWindow::view',
    'event_label': `${activityName}`,
    'non_interaction': true
  });

}


function accountRegisterGaView() {

  gtag('event', 'view', {
    'event_category': event_category,
    'event_action': 'signUpWindow::view',
    'event_label': `${activityName}`,
    'non_interaction': true
  });

}


function accountResetGaView() {

  gtag('event', 'view', {
    'event_category': event_category,
    'event_action': 'resetPasswordWindow::view',
    'event_label': `${activityName}`,
    'non_interaction': true
  });

}


function accountLoginGaClick(action) {
  var action = action.replace(/<.*?>/g, '')
  gtag('event', 'click', {
    'event_category': event_category,
    'event_action': 'btn::click',
    'event_label': `${activityName}::${action}`
  });

}


function accountRegisterGaClick(action) {
  var action = action.replace(/<.*?>/g, '')
  gtag('event', 'click', {
    'event_category': event_category,
    'event_action': 'btn::click',
    'event_label': `${activityName}::${action}`
  });

}


function accountResetGaClick(action) {
  var action = action.replace(/<.*?>/g, '')
  gtag('event', 'click', {
    'event_category': event_category,
    'event_action': 'btn::click',
    'event_label': `${activityName}::${action}`
  });

}